import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useStyles from './styles'
import { Dialog, DialogContent, Slide } from '@material-ui/core'
import { closeDialog } from 'actions/dialogs'
import LoginForm from 'components/LoginForm'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const LoginDialog = () => {
  const classes = useStyles()

  const dialog = useSelector(state => state.dialogs.login)

  const open = dialog !== undefined ? dialog.open : false
  const data = dialog !== undefined ? dialog.data : {}

  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(closeDialog('login'))
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent className={classes.dialogContent}>
        <LoginForm onComplete={handleClose} />
      </DialogContent>
    </Dialog>
  )
}

export default LoginDialog



// WEBPACK FOOTER //
// ./src/dialogs/Login/index.jsx